import React, {createContext, useContext, FC, ReactNode} from 'react';
import * as actions from "../actions/priceCatalogActions";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../../../redux/store";
import {messages as M} from '../../../../_metronic/i18n/messages';
import {showGlobalMessage} from "../../_common/components/GlobalMessage/actions/showGlobalMessage";

interface DeleteItemContextValue {
  id: number
  handleSubmit: () => Promise<void>
}

interface PriceCatalogProviderProps {
  id: number;
  children: ReactNode;
}

const DeleteItemContext = createContext<DeleteItemContextValue | null>(null);

export function useDeleteItemContext(): DeleteItemContextValue {
  const context = useContext(DeleteItemContext);
  if (!context) {
    throw new Error('useDeleteItemContext must be used within a PriceCatalogProvider');
  }
  return context;
}

export const DeleteItemProvider: FC<PriceCatalogProviderProps> = ({children, id}) => {
  const dispatch = useDispatch<AppDispatch>();

  const handleSubmit = async (): Promise<void> => {
    const result = await dispatch(actions.deleteItem({id}));

    if (result !== 0) {
      dispatch(showGlobalMessage('error', M['-1']));
    }
  };

  const value: DeleteItemContextValue = {
    id,
    handleSubmit
  };

  return (
    <DeleteItemContext.Provider value={value}>
      {children}
    </DeleteItemContext.Provider>
  );
};